import React from 'react';
import { IItemProps, IconTextButton, SelectFormItem } from 'ui-lib';
import deviceCss from './device-attributes.css';
import { useInteractiveAttribute } from './use-interactive-attribute';
import { DeviceInfosStore } from 'store/device-details/device-info-store';
import { DeviceAttributeName } from 'dto/device-dto';
import { observer } from 'mobx-react';

interface IInteractiveSubcard {
    deviceInfosStore: DeviceInfosStore;
    title: string;
    attributeName: DeviceAttributeName;
    initialValue: string;
    dataSource: IItemProps[];
    form?: any;
    afterFinish?: (updated: boolean, value?: string) => void;
}

export const InteractiveSubcardSelectFieldItem = observer((props: IInteractiveSubcard): React.ReactElement => {
    const { attributeName, title, initialValue, deviceInfosStore, form, dataSource, afterFinish } = props;

    const { editing, hasPermission, attributeValue, toggleEdit, onSaveAttribute, onUpdateAttribute } = useInteractiveAttribute({
        attributeName,
        deviceInfosStore,
        initialAttributeValue: initialValue,
        onDestroy: () => {
            form?.resetFields([attributeName]);
        },
        afterFinish
    });

    return (
        <div key={attributeName} className={deviceCss['sub-card']}>
            <h3>
                <span className={deviceCss['sub-card-title']}>{title}</span>
                <IconTextButton
                    key={`${attributeName}-action`}
                    className={deviceCss.editBtn}
                    onClick={toggleEdit}
                    hidden={!hasPermission}
                    iconName='edit'
                />
            </h3>
            {editing ? (
                <div style={{ display: 'inline-block', width: '100%' }}>
                    <SelectFormItem
                        code={attributeName}
                        dataSource={dataSource}
                        selectedValue={initialValue}
                        showSearch={true}
                        onChange={onUpdateAttribute}
                    />
                    <IconTextButton
                        className={deviceCss['attributeComponent']}
                        type='primary'
                        label='Ok'
                        onClick={() => onSaveAttribute(attributeValue)}
                    />
                </div>
            ) : (
                <span key={`span-${attributeName}`}>{initialValue}</span>
            )}
        </div>
    );
});
